/* eslint-disable @typescript-eslint/indent */
import { runtimeConfig } from '@app/common/config'

import { JobOpening } from './types'

if (!runtimeConfig.GREENHOUSE_ID) {
  throw new Error('GREENHOUSE_ID not provided')
}

export const GREENHOUSE_JOBS_URL = `https://boards-api.greenhouse.io/v1/boards/${runtimeConfig.GREENHOUSE_ID}/jobs?content=true`

export async function getGreenhouseJobs(): Promise<JobOpening[]> {
  const response = await fetch(GREENHOUSE_JOBS_URL)
  const data = await response.json()
  return data.jobs.map((item: any) => {
    return {
      id: item.id,
      title: item.title,
      location: item.location.name,
      updatedAp: item.updated_at,
      absoluteUrl: item.absolute_url,
      departments: item.departments
        ? item.departments.map((dep: any) => {
            const department = { name: dep.name, id: dep.id }
            return department
          })
        : [{ name: 'Global', id: 101011 }]
    }
  })
}
